module.exports = __webpack_public_path__ + "static/media/demo-7.b93f6dc4.jpg";